import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import { ArrowBack } from "@mui/icons-material";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import { useEffect, useState } from "react";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import { useBankFormHandling } from "./components/InsurerBankStateHandle";
import { useSnackbar } from "../../../context/popup";
import { setCircleLoading } from "../../../components/Loading";

const InsurerBankForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const bankId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" 
        ? "edit" : "add";
    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [generalBankOptions, setGeneralBankOptions] = useState([]);
    const { formData, setFormData, handleChange, checkAllFields } = useBankFormHandling();  
    
    useEffect(() => {
        if (pageMode === "add" || !bankId) {
            return;
        }
        //Fetch data by Pincode Id
        const fetchBankById = async (bankId) => {
            try {
            const response = await fetchDataById(`/reference/motor/insurer/bank/${bankId}`);

            const responseData = response?.data?.bank;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    code: responseData?.code || "",
                    isActive: responseData?.isActive,
                    gBank: {label: responseData?.gBankName, value: responseData?.gBankId},
                    gInsurer: {label: responseData?.gInsurerName, value: responseData?.gInsurerId},
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    codeStatus: responseData?.code ? "success" : "unchecked",
                    gBankStatus: responseData?.gBankId ? "success" : "unchecked",
                    gInsurerStatus: responseData?.gInsurerId ? "success" : "unchecked"

                };

                setFormData(mapped);  
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar(error?.response?.data?.message,"error");
            }
        };
        fetchBankById(bankId);
    }, [pageMode]);

    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, []);

    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            insurerResponse,
            bankResponse,
            ] = await Promise.all([
            fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`),
            fetchData(`/reference/general/bank?dropdown=true&isActive=true`),
            ]);

            const formattedInsurers = insurerResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.companyName,
            })) || [];

            const formattedBanks = bankResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name,
            })) || [];

            setGeneralInsurerOptions(formattedInsurers);
            setGeneralBankOptions(formattedBanks);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching Dropdown","warning");
        } finally {
            setCircleLoading(false);
        }
    };

    const handleSubmitBank = async () => {
        const payload = {
            // id: bankId,    //to be changed in api while updating
            gInsurerId: formData?.gInsurer?.value,
            gBankId: formData?.gBank?.value,
            name: formData?.name,
            code: formData?.code,
            isActive: formData?.isActive,
        };
        //Update
        if(bankId){
            try {
                const response = await putData(`/reference/insurer/bank/${bankId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/insurer-master/insurer-bank');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error");
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || "Error updating Bank","error");
            }
        }
        else{      
        //Submit
        try {
            const response = await postData('/reference/insurer/bank', payload);
            const responseMessage = response?.message;
            if(response?.success){
                //success message
                showSnackbar(responseMessage,"success");
                navigate('/insurer-master/insurer-bank');          
            }
            else{
                //error message
                showSnackbar(responseMessage,"error")
            }
        } catch (error) {
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message || "Error submitting bank","error");
            //catch error message
        }
        }
    };

  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
            <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/insurer-master/insurer-bank")}>
                            <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Insurer Bank Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New Bank Details to Insurer.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
            />
            <CardContent>
                <Grid2 container spacing={2}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Insurer
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gInsurer"
                        value={formData.gInsurer}
                        onChange={handleChange}
                        options={generalInsurerOptions}
                        success={formData.gInsurerStatus === "success"}
                        error={formData.gInsurerStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Bank
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gBank"
                        value={formData.gBank}
                        onChange={handleChange}
                        options={generalBankOptions}
                        success={formData.gBankStatus === "success"}
                        error={formData.gBankStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Bank Name
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Bank Name should be a minimum 1 character & maximum 100
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Bank Code
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        success={formData.codeStatus === "success"}
                        error={formData.codeStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.codeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Bank Code should be a minimum 1 character & maximum 20
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Actve
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.isActive}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "isActive",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.isActive ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
            <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            >
                {pageMode !== "view" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    onClick={() => navigate("/insurer-master/insurer-bank")}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleSubmitBank}
                    >
                    {pageMode === "edit" ? "Update" : "Submit"}
                    </MaterialButton>
                </>
                )}
            </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default InsurerBankForm